export default __webpack_public_path__ + "static/media/classic_band.6ed08c3d.png";